/* Mirae cart upsell — swaps the current bundle line for the next pack up
   in a single /cart/update.js call, then re-renders the drawer. */
class MiraeCartUpsell extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.mirae-cart__upsell-btn');
    if (this.button) {
      this.button.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick() {
    var oldId = this.dataset.oldVariant;
    var newId = this.dataset.newVariant;
    if (!oldId || !newId) return;

    this.button.setAttribute('aria-busy', 'true');

    var updates = {};
    updates[oldId] = 0;
    updates[newId] = 1;

    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var updateUrl = root + 'cart/update.js';

    fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (!state.sections) return;
        MiraeCartUpsell.renderSections(state.sections);
      })
      .catch(function (e) {
        console.error('Mirae upsell error', e);
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
        this.button.removeAttribute('aria-busy');
      }.bind(this));
  }

  static renderSections(sections) {
    if (sections['cart-drawer']) {
      var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (selector) {
        var target = document.querySelector(selector);
        var source = html.querySelector(selector);
        if (target && source) target.replaceWith(source);
      });
    }

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var bubbleHtml = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var inner = bubbleHtml.querySelector('.shopify-section');
        bubble.innerHTML = inner ? inner.innerHTML : sections['cart-icon-bubble'];
      }
    }
  }
}

if (!customElements.get('mirae-cart-upsell')) {
  customElements.define('mirae-cart-upsell', MiraeCartUpsell);
}
